import React, { useState,useEffect ,useSelector } from "react";
import { useParams } from "react-router-dom";
import { auth, db } from "../../firebase";
import { getDatabase, ref, onValue, set } from "firebase/database";
import '../../style/WaitinscreenCrowd.css';

export default function WaitingScreen({onNavigate, code: propCode}) {
    const { code: urlCode } = useParams();
    const code = propCode || urlCode;
    const { slug } = useParams();
    const initial = localStorage.getItem('initials');
    const fullname = localStorage.getItem('name');
    const profileColor = localStorage.getItem('profileColor');
    const [participants, setParticipants] = useState([]);
    const isScrollable = participants.length > 6;
    useEffect(() => {
      if (code) {
        handleFirebaseUpdatebycode();
      }else{
        handleFirebaseUpdatesbyslug();
      }
    }, [code, onNavigate]);

    // window.exitgame is set by parent App.js component - no need to set it here

    const handleFirebaseUpdatebycode = () => {
      const database = getDatabase(); // Initialize Firebase Database
      const refPath = ref(database, `AppleTV/${code}`);
      let previousData;

      // console.log(code, "code");

      onValue(refPath, (snapshot) => {
        const data = snapshot.val();
        if (data !== previousData) {
          // console.log("Data updated:", data);
          previousData = data;

          // Check if participant game has started and navigate
          if (data && data.isParticipantGameStarted) {
            onNavigate('LeaderBoard');
          }

          // Map team participants if data contains teamNames
          const teamParticipants = data && 'teamNames' in data ? data.teamNames.map((team) => ({
            initials: team.initials,
            name: team.name,
            profileColor: team.profileColor,
          })) : [];

          setParticipants(teamParticipants);
        }
      });
    };
    const handleFirebaseUpdatesbyslug = () => {
      const database = getDatabase(); // Initialize Firebase Database
      const refPath = ref(database, `AppleTV/${slug}`);
      let previousData;

      console.log(slug, "slug");

      onValue(refPath, (snapshot) => {
        const data = snapshot.val();
        if (data !== previousData) {
          console.log("Data updated:", data);
          previousData = data;

          // Check if participant game has started and navigate
          if (data && data.isParticipantGameStarted) {
            onNavigate('LeaderBoard');
          }

          // Map team participants if data contains teamNames
          const teamParticipants = data && 'teamNames' in data ? data.teamNames.map((team) => ({
            initials: team.initials,
            name: team.name,
            profileColor: team.profileColor,
          })) : [];

          setParticipants(teamParticipants);
        }
      });
    };

  return (
    <div className="waiting-room-container row">
      <div className="col-xl-4 col-lg-3 col-md-2 col-sm-1 col-xs-0"></div>
      <div className="col-xl-4 col-lg-6 col-md-8 col-sm-10 col-xs-12 waiting-room-content">
        <div className='firstconatiner'>
        <div className="launch-title-container">
          <span className="launch-title" id="launchhosttitle">The host will launch the game soon</span>
        </div>
        <div className="selected-img-color">
          <span id="userbgcolor" className="animal-circle circle-height-width" style={{ fontSize: '50px', background: profileColor, color: 'white' }}>{initial}</span>
        </div>
        <div className="selected-name">
          <span id="selecedavtarname" className="animalscreenlable" style={{ fontSize: '30px', color: 'skyblue' }}>{fullname}</span>
        </div>
        </div>
        
        <div className="remaining-players-container">
            <div className='players-conatainer'>
          <div className="connected-users-container">
            <div className="connected-users">
            <span id="connecteduserid" className="animal-circle connected-users-span">
  {participants.length > 0 ? participants.length - 1 : participants.length}
</span>

            </div>
            <div className="other-players">
              <span id="otherplayerspan" className='otherplayerspan' style={{ fontSize: '2em', margin: '15px', color: 'white' }}>Other Players</span>
            </div>
            </div>
          </div>
          </div>
          
          <div
      id="remainingplayerdiv"
      className="remaining-players"
      style={{
        // Dynamically applying styles
        maxHeight: isScrollable ? '200px' : 'auto',  // Apply max-height if scrollable
        overflowY: isScrollable ? 'auto' : 'visible', // Enable scrolling only if necessary
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on mobile
      }}
    >
      {participants.map((participant, index) => {
        if (participant.initials !== initial) {
          return (
            <div
              key={index}
              className="animal-circle animal-icon-div zoom-in-zoom-out"
              style={{
                background: participant.profileColor,
                fontSize: '25px',
                color: 'white',
              }}
            >
              {participant.initials}
            </div>
          );
        } else {
          return null;
        }
      })}
    </div>

      </div>
   
      <div className="col-xl-4 col-lg-3 col-md-2 col-sm-1 col-xs-0"></div>
    </div>
  )
}